const thematic2 = [
  {
    "id": 12,
    "date": "2022-09-04T19:28:13",
    "date_gmt": "2022-09-04T19:28:13",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/?p=12"
    },
    "modified": "2022-09-04T19:28:13",
    "modified_gmt": "2022-09-04T19:28:13",
    "slug": "usage-of-medical-jargon-in-clinician-and-patient-communication-and-minimal-english-as-the-solution",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/2022/09/04/usage-of-medical-jargon-in-clinician-and-patient-communication-and-minimal-english-as-the-solution/",
    "title": {
      "rendered": "Usage of medical jargon in clinician and patient communication and Minimal English as the solution"
    },
    "content": {
      "rendered": "\u003Cdiv class=\"page\" title=\"Page 6\"\u003E\n\u003Cdiv class=\"section\"\u003E\n\u003Cdiv class=\"layoutArea\"\u003E\n\u003Cdiv class=\"column\"\u003E\n\u003Cdiv class=\"page\" title=\"Page 6\"\u003E\n\u003Cdiv class=\"section\"\u003E\n\u003Cdiv class=\"layoutArea\"\u003E\n\u003Cdiv class=\"column\"\u003E\n\u003Cp\u003E\u003Cstrong\u003EModule:\u003C/strong\u003E RVX1002 ‘What do you mean?’ Meaning and communication in intercultural contexts\u003Cbr /\u003E\n\u003Cstrong\u003EPresenter:\u003C/strong\u003E Yoon Su Lin\u003C/p\u003E\n\u003Cdiv class=\"page\" title=\"Page 6\"\u003E\n\u003Cdiv class=\"section\"\u003E\n\u003Cdiv class=\"layoutArea\"\u003E\n\u003Cdiv class=\"column\"\u003E\n\u003Cp\u003E\u003Cstrong\u003EAbstract:\u003C/strong\u003E\u003Cbr /\u003E\nThis paper explores the heavy usage of medical jargon by clinicians to the patients and how this affects the communication and the relationship between the two parties. Medical terminology comes to clinicians naturally. However, this might not be the case for patients and might not be understood across all cultures and languages. The paper investigates the issue by reading thesis papers and exploring the previous attempts to solve this heavy medical jargon used to better the relationship between clinicians and patients. In an attempt to improve communication between patients and clinicians, this paper explores Minimal English as a solution and how this as a tool can minimize the panic and misunderstanding caused due to medical jargon. In this paper, Minimal English has been used to translate certain medical words such as &#8220;acute&#8221; and &#8220;chronic&#8221; illnesses in a way which can be universally understood across all cultures and languages.\u003C/p\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003EModule: RVX1002 ‘What do you mean?’ Meaning and communication in intercultural contexts Presenter: Yoon Su Lin Abstract: This paper explores the heavy usage of medical jargon by clinicians to the patients and how this affects the communication and the relationship between the two parties. Medical terminology comes to clinicians naturally. However, this might not be [&hellip;]\u003C/p\u003E\n",
      "protected": false
    },
    "author": 32564,
    "featured_media": 0,
    "comment_status": "open",
    "ping_status": "open",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "footnotes": ""
    },
    "categories": [1],
    "tags": [],
    "class_list": [
      "post-12",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-uncategorized"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts/12",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/users/32564"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/comments?post=12"
        }
      ],
      "version-history": [
        {
          "count": 1,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts/12/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 13,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts/12/revisions/13"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/media?parent=12"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/categories?post=12"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/tags?post=12"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 10,
    "date": "2022-09-04T19:27:37",
    "date_gmt": "2022-09-04T19:27:37",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/?p=10"
    },
    "modified": "2022-09-04T19:27:37",
    "modified_gmt": "2022-09-04T19:27:37",
    "slug": "the-story-behind-ice-kachang",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/2022/09/04/the-story-behind-ice-kachang/",
    "title": {
      "rendered": "The Story Behind Ice Kachang"
    },
    "content": {
      "rendered": "\u003Cdiv class=\"page\" title=\"Page 6\"\u003E\n\u003Cdiv class=\"section\"\u003E\n\u003Cdiv class=\"layoutArea\"\u003E\n\u003Cdiv class=\"column\"\u003E\n\u003Cp\u003E\u003Cstrong\u003EModule:\u003C/strong\u003E RVSS1002 Feeding the Belly of a Nation\u003Cbr /\u003E\n\u003Cstrong\u003EPresenter:\u003C/strong\u003E Khoo Wei Zhi/ Lim Yi Ter/ Rachel Tan Limin/ Yeoh Jun Ting\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAbstract:\u003C/strong\u003E\u003Cbr /\u003E\nThe Singaporean food culture is much more than the food we eat or the places we enjoy them in. In our opinion, Singapore’s food culture transcends these physical aspects. It is the memories and stories that accompany the food we eat that give them a unique sentiment and identity that is uniquely Singaporean. Sadly, some of these stories and foods will inevitably be lost to time. Our project is a story about the Ice Kachang, a dessert from our parents’ generation. We recollect how it was a delightful and refreshing treat on a hot afternoon, and trace its fortunate development into what we know as Ice Kachang today. By sharing this story, we hope that our peers will be able to appreciate the local cuisine more, passing down their individual experiences with the local cuisine for future generations, and in this process preserve the unique Singaporean food culture.\u003C/p\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003EModule: RVSS1002 Feeding the Belly of a Nation Presenter: Khoo Wei Zhi/ Lim Yi Ter/ Rachel Tan Limin/ Yeoh Jun Ting Abstract: The Singaporean food culture is much more than the food we eat or the places we enjoy them in. In our opinion, Singapore’s food culture transcends these physical aspects. It is the memories [&hellip;]\u003C/p\u003E\n",
      "protected": false
    },
    "author": 32564,
    "featured_media": 0,
    "comment_status": "open",
    "ping_status": "open",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "footnotes": ""
    },
    "categories": [1],
    "tags": [],
    "class_list": [
      "post-10",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-uncategorized"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts/10",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/users/32564"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/comments?post=10"
        }
      ],
      "version-history": [
        {
          "count": 1,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts/10/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 11,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts/10/revisions/11"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/media?parent=10"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/categories?post=10"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/tags?post=10"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 8,
    "date": "2022-09-04T19:26:48",
    "date_gmt": "2022-09-04T19:26:48",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/?p=8"
    },
    "modified": "2022-09-04T19:26:48",
    "modified_gmt": "2022-09-04T19:26:48",
    "slug": "on-objectivism-and-the-fall-of-rapture-a-critical-inquiry-of-rational-egoism-and-negative-libertarianism",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/2022/09/04/on-objectivism-and-the-fall-of-rapture-a-critical-inquiry-of-rational-egoism-and-negative-libertarianism/",
    "title": {
      "rendered": "On Objectivism and the Fall of Rapture: A Critical Inquiry of Rational Egoism and Negative Libertarianism"
    },
    "content": {
      "rendered": "\u003Cdiv class=\"page\" title=\"Page 5\"\u003E\n\u003Cdiv class=\"section\"\u003E\n\u003Cdiv class=\"layoutArea\"\u003E\n\u003Cdiv class=\"column\"\u003E\n\u003Cp\u003E\u003Cstrong\u003EModule:\u003C/strong\u003E RVX1001 Science Fiction and Society\u003Cbr /\u003E\n\u003Cstrong\u003EPresenter:\u003C/strong\u003E Jonathan Derryl Kartjito\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAbstract:\u003C/strong\u003E\u003Cbr /\u003E\nBioshock (2007) is a science-fiction first-person shooter (FPS) videogame set in the ruins of Rapture, a failed Utopian underwater city with Objectivism as its founding philosophy. Bioshock, despite its age, criticises economic and socio-political ideas that have become increasingly more prevalent in recent years, namely rational egoism (self-centred decision-making) and negative libertarianism (undisputed freedom) – Objectivism’s principal tenets. During the COVID-19 pandemic, while poverty levels skyrocketed due to mass unemployment, billionaires worldwide have become increasingly wealthy thanks to an economic system motivated solely by individual profit, capitalism. Many also cited ‘medical freedom’ to justify disobeying health protocols – endangering themselves and others. Hence, to better understand the ideologies behind such behaviours, this essay will analyse the question “How does Rapture&#8217;s downfall expose the inherent flaws within Objectivism&#8217;s principles of rational egoism and libertarianism?” Through its storytelling, lore, and mechanics, Bioshock encourages critical discourse surrounding notions of self-interest and freedom, rejecting absolute ideologies like Objectivism.\u003C/p\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003EModule: RVX1001 Science Fiction and Society Presenter: Jonathan Derryl Kartjito Abstract: Bioshock (2007) is a science-fiction first-person shooter (FPS) videogame set in the ruins of Rapture, a failed Utopian underwater city with Objectivism as its founding philosophy. Bioshock, despite its age, criticises economic and socio-political ideas that have become increasingly more prevalent in recent years, [&hellip;]\u003C/p\u003E\n",
      "protected": false
    },
    "author": 32564,
    "featured_media": 0,
    "comment_status": "open",
    "ping_status": "open",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "footnotes": ""
    },
    "categories": [1],
    "tags": [],
    "class_list": [
      "post-8",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-uncategorized"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts/8",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/users/32564"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/comments?post=8"
        }
      ],
      "version-history": [
        {
          "count": 1,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts/8/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 9,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts/8/revisions/9"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/media?parent=8"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/categories?post=8"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/tags?post=8"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 6,
    "date": "2022-09-04T19:26:23",
    "date_gmt": "2022-09-04T19:26:23",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/?p=6"
    },
    "modified": "2022-09-04T19:26:23",
    "modified_gmt": "2022-09-04T19:26:23",
    "slug": "online-citizen-discourses-of-income-inequality-in-singapore",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/2022/09/04/online-citizen-discourses-of-income-inequality-in-singapore/",
    "title": {
      "rendered": "Online citizen discourses of income inequality in Singapore"
    },
    "content": {
      "rendered": "\u003Cdiv class=\"page\" title=\"Page 5\"\u003E\n\u003Cdiv class=\"section\"\u003E\n\u003Cdiv class=\"layoutArea\"\u003E\n\u003Cdiv class=\"column\"\u003E\n\u003Cp\u003E\u003Cstrong\u003EModule:\u003C/strong\u003E RVX1000 Citizen Speak: Persuasion and Polarization in Society\u003Cbr /\u003E\n\u003Cstrong\u003EPresenter:\u003C/strong\u003E Yi Ter Lim\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAbstract:\u003C/strong\u003E\u003Cbr /\u003E\nThe complexities of navigating competing facets of meritocracy in its continued application to Singapore society has generated much online citizen discourse in recent years. Narratives of meritocracy as justification for income inequality are increasingly being challenged by ordinary Singaporeans on the internet. Through examining the rhetorical strategies used to advance alternative narratives, the nature and implications of citizen discourse and participation in Singapore can be better understood. I conducted a rhetorical analysis on comments to a Reddit post questioning the use of meritocracy in Singapore and identified three rhetorical strategies: the metaphor of sports, questioning assumptions, and the rhetoric of anti- elitism. I further studied how these strategies were used to counter state narratives and discussed implications of their use. My analysis shows that while ordinary Singaporeans employ various rhetorical strategies in challenging state narratives, some strategies might be more useful than others in effecting policy change.\u003C/p\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003EModule: RVX1000 Citizen Speak: Persuasion and Polarization in Society Presenter: Yi Ter Lim Abstract: The complexities of navigating competing facets of meritocracy in its continued application to Singapore society has generated much online citizen discourse in recent years. Narratives of meritocracy as justification for income inequality are increasingly being challenged by ordinary Singaporeans on the [&hellip;]\u003C/p\u003E\n",
      "protected": false
    },
    "author": 32564,
    "featured_media": 0,
    "comment_status": "open",
    "ping_status": "open",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "footnotes": ""
    },
    "categories": [1],
    "tags": [],
    "class_list": [
      "post-6",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-uncategorized"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts/6",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/users/32564"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/comments?post=6"
        }
      ],
      "version-history": [
        {
          "count": 1,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts/6/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 7,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts/6/revisions/7"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/media?parent=6"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/categories?post=6"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/tags?post=6"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 4,
    "date": "2022-08-04T19:23:25",
    "date_gmt": "2022-08-04T19:23:25",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/?p=4"
    },
    "modified": "2022-09-04T19:25:56",
    "modified_gmt": "2022-09-04T19:25:56",
    "slug": "pink-dot-amid-the-pandemic-rhetoric-of-the-social-movement-in-the-online",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/2022/08/04/pink-dot-amid-the-pandemic-rhetoric-of-the-social-movement-in-the-online/",
    "title": {
      "rendered": "Pink Dot amid the pandemic: Rhetoric of the social movement in the online"
    },
    "content": {
      "rendered": "\u003Cdiv class=\"page\" title=\"Page 4\"\u003E\n\u003Cdiv class=\"section\"\u003E\n\u003Cdiv class=\"layoutArea\"\u003E\n\u003Cdiv class=\"column\"\u003E\n\u003Cp\u003E\u003Cstrong\u003EModule:\u003C/strong\u003E RVX1000 Citizen Speak: Persuasion and Polarization in Society\u003Cbr /\u003E\n\u003Cstrong\u003EPresenter:\u003C/strong\u003E Yong Xian Dan\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAbstract:\u003Cbr /\u003E\n\u003C/strong\u003EThis essay analyses the rhetorical changes made by the social movement Pink Dot in response to the Covid-19 pandemic, to understand the impact of the pandemic on social movements. Through an analysis of videos made by the Pink Dot during the pandemic and comparing them to pre-pandemic outreach efforts, I posit that Covid-19 has shifted Pink Dot into the online space and forced the movement to adapt its rhetorical practices. Specifically, Pink Dot has increased its online presence, and ramped up usage of Standard Singapore English and focus on familial support. I argue that these changes are largely due, but not limited to, Covid-19’s societal impact, and this may have been but a catalyst that warranted the changes earlier. Ultimately, the discussion of Pink Dot’s rhetorical adaptation points out how social developments like Covid-19 initiate responses by social movements to tackle new problems, and what these responses may look like.\u003C/p\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n\u003C/div\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003EModule: RVX1000 Citizen Speak: Persuasion and Polarization in Society Presenter: Yong Xian Dan Abstract: This essay analyses the rhetorical changes made by the social movement Pink Dot in response to the Covid-19 pandemic, to understand the impact of the pandemic on social movements. Through an analysis of videos made by the Pink Dot during the [&hellip;]\u003C/p\u003E\n",
      "protected": false
    },
    "author": 32564,
    "featured_media": 0,
    "comment_status": "open",
    "ping_status": "open",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "footnotes": ""
    },
    "categories": [1],
    "tags": [],
    "class_list": [
      "post-4",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-uncategorized"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts/4",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/users/32564"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/comments?post=4"
        }
      ],
      "version-history": [
        {
          "count": 1,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts/4/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 5,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/posts/4/revisions/5"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/media?parent=4"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/categories?post=4"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/rvrcsymposium2022thematic2/wp-json/wp/v2/tags?post=4"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  }
];

export default thematic2;